/**
 * POST `admin/clients/:id/archive` — архивировать клиента (ADMIN_SPEC §9).
 * Опасное действие → подтверждение в UI; причина уезжает в аудит.
 * Мок имитирует задержку и успех для optimistic-flow.
 */

import {apiEnabled, http} from '@services/utils';

import {MOCK_CLIENTS} from '../mocks';

export type ArchiveClientInput = {
  id: string;
  reason?: string;
};

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const archiveClient = async (input: ArchiveClientInput): Promise<{ok: true}> => {
  if (!apiEnabled) {
    await sleep(300);
    const row = MOCK_CLIENTS.find((c) => c.id === input.id);
    if (row) {
      row.subscriptionStatus = 'cancelled';
      row.currentPeriodEnd = null;
      row.trialDay = null;
    }
    return {ok: true};
  }

  await http(`admin/clients/${encodeURIComponent(input.id)}/archive`, {
    method: 'POST',
    body: {reason: input.reason?.trim() ? input.reason.trim() : null},
    skipCaseConversion: true,
  });
  return {ok: true};
};
